import UsefulResources from "../component/UsefulResources/UsefulResources";

function UsefulResourcesPage(props) {
  return (
    <div>
      <UsefulResources />
    </div>
  );
}

export default UsefulResourcesPage;
